export default __webpack_public_path__ + "6fcfb5caa5cb64e8a156f80b406a7711.webp";